import React from 'react'
import { Link } from 'react-router-dom'
import { ContactInfo } from '../ContactInfo/ContactInfo'

export const Cv = () => {


  return (
    <section className='bg-slate-50	'>
      <figure className='cvContainer m-auto mt-10 w-4/5 2xl:w-3/5'>
        <img 
          src={process.env.PUBLIC_URL + '/assets/cv/cv1.png'} 
          className='h-full border-8	border-slate-900 rounded-xl	'   
          alt="Imagen de curriculum Vitae" />
      </figure>
      <ContactInfo/>
      <div className="flex justify-center align-center p-5">
        <Link 
          to='/' 
          className="btn btn-primary flex justify-self-center	 self-center	w-1/5 "
          >
            Volver
        </Link>
      </div>
    </section>
  )
}
